import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { GetInvitationResponse } from 'src/types/rest/managementPortalApi';

export const useInvitation = (
  code?: string,
  options?: Partial<UseQueryOptions<GetInvitationResponse>>,
) => {
  const {
    managementPortalApi: { apiHost },
  } = useAppConfig();

  return useQuery({
    queryFn: () =>
      apiRequest<GetInvitationResponse>({
        url: `${apiHost}/invitations/${code}`,
      }),
    queryKey: ['invitation', code],
    ...options,
    /**
     * Combined explicitly so a caller-provided `enabled` (e.g. gating on
     * authorization) can't accidentally re-enable the query when there's no
     * code to fetch.
     */
    enabled: !!code && (options?.enabled ?? true),
  });
};
